// Modules
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

// Pages
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { ErrorComponent } from './pages/error/error.component';
import { AllSupplyComponent } from './pages/supply/all-supply/all-supply.component';
import { SupplyByDayComponent } from './pages/supply/supply-by-day/supply-by-day.component';
import { SupplyByDomainComponent } from './pages/supply/supply-by-domain/supply-by-domain.component';
import { SupplyByDemandComponent } from './pages/supply/supply-by-demand/supply-by-demand.component';
import { LegacyPublisherReportsComponent } from './pages/publishers/legacy-publisher-reports/legacy-publisher-reports.component';
import { ManageSupplyComponent } from './pages/supply/manage-supply/manage-supply.component';
import { NewSupplyComponent } from './pages/supply/new-supply/new-supply.component';
import { PublishersReportAllComponent } from './pages/publishers/publishers-report-all/publishers-report-all.component';
import { AllDemandComponent } from './pages/demand/all-demand/all-demand.component';
import { DemandBySupplyComponent } from './pages/demand/demand-by-supply/demand-by-supply.component';
import { DemandByDayComponent } from './pages/demand/demand-by-day/demand-by-day.component';
import { DemandByDomainComponent } from './pages/demand/demand-by-domain/demand-by-domain.component';
import { ManageDemandComponent } from './pages/demand/manage-demand/manage-demand.component';
import { NewDemandComponent } from './pages/demand/new-demand/new-demand.component';
import { QualityAndViewabilityComponent } from './pages/quality/quality-and-viewability/quality-and-viewability.component';
import { QualityBySupplyComponent } from './pages/quality/quality-by-supply/quality-by-supply.component';
import { QualityByDemandComponent } from './pages/quality/quality-by-demand/quality-by-demand.component';
import { ManageCDNComponent } from './pages/cdn/manage-cdn/manage-cdn.component';
import { UsageCDNComponent } from './pages/cdn/usage-cdn/usage-cdn.component';
import { ManageListComponent } from './pages/list/manage-list/manage-list.component';
import { NewListComponent } from './pages/list/new-list/new-list.component';
import { ManagePublishersComponent } from './pages/publishers/manage-publishers/manage-publishers.component';
import { NewPublisherComponent } from './pages/publishers/new-publisher/new-publisher.component';
import { UserSettingsComponent } from './pages/settings/user-settings/user-settings.component';
import { NetworkSettingsComponent } from './pages/settings/network-settings/network-settings.component';

// Components
import { ActivityLogComponent } from './components/activity-log/activity-log.component';
import { FlashMessagesComponent } from './components/flash-messages/flash-messages.component';
import { ModalComponent } from './components/modal/modal.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { NavigateAwayComponent } from './components/navigate-away/navigate-away.component';
import { ModalCedatoComponent } from './components/modal-cedato/modal-cedato.component';
import { MessagesComponent } from './components/messages/messages.component';
import { ManageCampaignsComponent } from './pages/campaigns/manage-campaigns/manage-campaigns.component';
import { NewCampaignComponent } from './pages/campaigns/new-campaign/new-campaign.component';
import { ManageRtbPartnersComponent } from './pages/rtb_partners/manage-rtb-partners/manage-rtb-partners.component';
import { NewRtbPartnerComponent } from './pages/rtb_partners/new-rtb-partner/new-rtb-partner.component';

// Modals
import { HelpComponent } from './modals/help/help.component';
import { AddBroadcastComponent } from './modals/add-broadcast/add-broadcast.component';
import { AddNetworkComponent } from './modals/add-network/add-network.component';
import { AddUserComponent } from './modals/add-user/add-user.component';
import { AvailableMacrosComponent } from './modals/available-macros/available-macros.component';
import { CdnFileDeleteComponent } from './modals/cdn-file-delete/cdn-file-delete.component';
import { CdnFileUploadComponent } from './modals/cdn-file-upload/cdn-file-upload.component';
import { CdnFileUpdateComponent } from './modals/cdn-file-update/cdn-file-update.component';
import { CedatoXConfirmComponent } from './modals/cedatox-confirm/cedatox-confirm.component';
import { ReportActionsComponent } from './modals/report-actions/report-actions.component';
import { RegenerateKeyConfirmComponent } from './modals/regenerate-key-confirm/regenerate-key-confirm.component';
import { DeleteNetworkComponent } from './modals/delete-network/delete-network.component';
import { PostbidAlertComponent } from './modals/postbid-alert/postbid-alert.component';
import { DeleteListConfirmComponent } from './modals/delete-list-confirm/delete-list-confirm.component';
import { PostbidOptOutComponent } from './modals/postbid-opt-out/postbid-opt-out.component';
import { GdprAgreementComponent } from './modals/gdpr-agreement/gdpr-agreement.component';
import { CxRevshareConfirmComponent } from './modals/cx-revshare-confirm/cx-revshare-confirm.component';
import { TimezoneComponent } from './modals/timezone/timezone.component';
import { ConfirmAssignComponent } from './modals/confirm-assign/confirm-assign.component';
import { FeatureFlagsAllNetworksComponent } from './modals/feature-flags-all-networks/feature-flags-all-networks';
import { ConfirmLimitAssignComponent } from './modals/confirm-limit-assign/confirm-limit-assign.component';
import { ContentEventsComponent } from './pages/content-events/content-events.component';
import { PrebidDemandComponent } from './components/prebid-demand/prebid-demand.component';
import { PrebidOptionalParamsComponent } from './components/prebid-optional-params/prebid-optional-params.component';

// NgModule
@NgModule({
  declarations: [
    // Pages
    HomeComponent,
    LoginComponent,
    ErrorComponent,
    AllSupplyComponent,
    SupplyByDayComponent,
    SupplyByDomainComponent,
    SupplyByDemandComponent,
    LegacyPublisherReportsComponent,
    ManageSupplyComponent,
    NewSupplyComponent,
    AllDemandComponent,
    DemandBySupplyComponent,
    DemandByDayComponent,
    DemandByDomainComponent,
    ManageDemandComponent,
    NewDemandComponent,
    QualityAndViewabilityComponent,
    QualityBySupplyComponent,
    QualityByDemandComponent,
    ManageCDNComponent,
    UsageCDNComponent,
    ManageListComponent,
    NewListComponent,
    ManagePublishersComponent,
    NewPublisherComponent,
    UserSettingsComponent,
    NetworkSettingsComponent,
    // Components
    ActivityLogComponent,
    FlashMessagesComponent,
    ModalComponent,
    NavbarComponent,
    SideMenuComponent,
    TooltipComponent,
    NavigateAwayComponent,
    ModalCedatoComponent,
    MessagesComponent,
    // Modals
    CdnFileUploadComponent,
    AddNetworkComponent,
    AvailableMacrosComponent,
    CdnFileDeleteComponent,
    AddBroadcastComponent,
    AddUserComponent,
    CedatoXConfirmComponent,
    ReportActionsComponent,
    RegenerateKeyConfirmComponent,
    DeleteNetworkComponent,
    HelpComponent,
    PostbidAlertComponent,
    DeleteListConfirmComponent,
    GdprAgreementComponent,
    PostbidOptOutComponent,
    CxRevshareConfirmComponent,
    TimezoneComponent,
    ConfirmAssignComponent,
    FeatureFlagsAllNetworksComponent,
    ConfirmLimitAssignComponent,
    ContentEventsComponent,
    CdnFileUpdateComponent,
    PublishersReportAllComponent,
    ManageCampaignsComponent,
    NewCampaignComponent,
    ManageRtbPartnersComponent,
    NewRtbPartnerComponent,
    PrebidDemandComponent,
    PrebidOptionalParamsComponent,
  ],
  exports: [
    // Pages
    LoginComponent,
    ErrorComponent,
    AllSupplyComponent,
    SupplyByDayComponent,
    SupplyByDomainComponent,
    SupplyByDemandComponent,
    ManageSupplyComponent,
    NewSupplyComponent,
    AllDemandComponent,
    DemandBySupplyComponent,
    DemandByDayComponent,
    DemandByDomainComponent,
    ManageDemandComponent,
    NewDemandComponent,
    QualityAndViewabilityComponent,
    QualityBySupplyComponent,
    QualityByDemandComponent,
    ManageCDNComponent,
    UsageCDNComponent,
    ManageListComponent,
    NewListComponent,
    ManagePublishersComponent,
    NewPublisherComponent,
    UserSettingsComponent,
    NetworkSettingsComponent,
    // Components
    ActivityLogComponent,
    FlashMessagesComponent,
    ModalComponent,
    NavbarComponent,
    SideMenuComponent,
    TooltipComponent,
    NavigateAwayComponent,
    ModalCedatoComponent,
    MessagesComponent,
    // Modals
    CdnFileUploadComponent,
    AddNetworkComponent,
    AvailableMacrosComponent,
    CdnFileDeleteComponent,
    AddBroadcastComponent,
    AddUserComponent,
    CedatoXConfirmComponent,
    ReportActionsComponent,
    RegenerateKeyConfirmComponent,
    DeleteNetworkComponent,
    HelpComponent,
    PostbidAlertComponent,
    DeleteListConfirmComponent,
    GdprAgreementComponent,
    PostbidOptOutComponent,
    CxRevshareConfirmComponent,
    TimezoneComponent,
    ConfirmAssignComponent,
  ],
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule {}
